import { useState, useEffect } from 'react';
import {useTranslation} from "react-i18next";

export const NahrainIncrementalInput = ({
                                            className = '',
                                            min = 0,
                                            max = 5,
                                            initialValue = 0,
                                            onChange,
                                            step = 0.5,
                                            label = ''
                                        }) => {
    const [value, setValue] = useState(Math.max(min, Math.min(max, initialValue)));

    useEffect(() => {
        onChange?.(value);
    }, [value, onChange]);

    const handleIncrement = () => {
        setValue(prev => Math.min(max, prev + step));
    };

    const handleDecrement = () => {
        setValue(prev => Math.max(min, prev - step));
    };

    const handleInputChange = (e) => {
        const input = e.target.value;
        if (input === "") {
            setValue("");
            return;
        }

        const newValue = parseFloat(input);
        if (!isNaN(newValue)) {
            setValue(Math.max(min, Math.min(max, newValue)));
        }
    };
    const [t] = useTranslation("global");


    return (
        <div className={`${className} flex flex-col gap-2 w-fit`}>
            {label && <label className="text-onBackgroundCaption">{label}</label>}
            <div className="flex items-center border border-strokeGray rounded-lg overflow-hidden">
                <button
                    className="px-4 py-3 bg-primary text-onPrimary disabled:opacity-80"
                    onClick={handleDecrement}
                    disabled={value <= min}
                    type="button"
                >
                    -
                </button>
                <div className={`flex-1 py-3 px-4`}>
                    <input
                        type="number"
                        className=" bg-transparent w-6 text-onBackground text-center focus:outline-none"
                        value={value === "" ? "" : value}
                        min={min}
                        max={max}
                        onChange={handleInputChange}
                    />
                    <span className={`text-onBackgroundCaption`}>{t("hour_abbreviation")}</span>
                </div>


                <button
                    className="px-4 py-3 bg-primary text-onPrimary disabled:opacity-80"
                    onClick={handleIncrement}
                    disabled={value >= max}
                    type="button"
                >
                    +
                </button>
            </div>
        </div>
    );
};